var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('ul',{staticClass:"nav"},_vm._l((_vm.navList),function(item,index){return _c('li',{key:index,class:{
            active:
              _vm.path.indexOf(item.href) > -1 || _vm.path.indexOf(item.detail) > -1,
          }},[_c('router-link',{class:{
            active_text:
              _vm.path.indexOf(item.href) > -1 || _vm.path.indexOf(item.detail) > -1,
          },attrs:{"to":item.base + item.href}},[_vm._v(_vm._s(item.name))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }